import { type FC } from 'react';
import ProductIcon from '@assets/img/dice-game/goods-card.svg?react';
import MaterialsIcon from '@assets/img/dice-game/material-card.svg?react';
import ResourceIcon from '@assets/img/dice-game/resource-card.svg?react';
import StopIcon from '@assets/img/icons/stop.svg?react';
import cn from 'classnames';

import { H2, StringMain } from '@/components/Typography/Typography';
import { Picture } from '@/components/ui/Picture/Picture';
import { useAppSelector } from '@/redux/store';

import css from './styles.module.scss';

import bombPng from '/img/dice-game/bomb.png';
import bombWebp from '/img/dice-game/bomb.webp';
import zeroPng from '/img/dice-game/zero.png';
import zeroWebp from '/img/dice-game/zero.webp';
import cashPng from '/img/icons/cash-large.png';
import cashWebp from '/img/icons/cash-large.webp';

interface CardsOptionsProps {
  className?: string;
}

const CardsOptions: FC<CardsOptionsProps> = ({ className }) => {
  const options = useAppSelector(
    (state) => state.diceGame.cardsMiniGameOptions,
  );
  const gameKind = useAppSelector((state) => state.diceGame.miniGame?.type);

  const pictureKinds = ['bomb', 'empty'];

  const pictureClassName = 'w-[min(3.45svh,_2rem)] h-[min(3.45svh,_2rem)]';

  return (
    <div className={cn('flex items-center gap-6', className)}>
      {Object.entries(options || {}).map(([kind, quantity], index) => {
        const images = {
          mainPrize: {
            png: cashPng,
            webp: cashWebp,
          },
          bomb: {
            png: bombPng,
            webp: bombWebp,
          },
          empty: {
            png: zeroPng,
            webp: zeroWebp,
          },
        };

        const image =
          kind in images ? images[kind as keyof typeof images] : undefined;

        return (
          <div
            key={index}
            className={cn('flex items-center', quantity === 0 && 'opacity-50')}
          >
            {(pictureKinds.includes(kind) ||
              (kind === 'mainPrize' && gameKind === 'cash')) &&
              image && (
                <Picture
                  className={pictureClassName}
                  img={image.png}
                  alt={kind}
                />
              )}
            {kind === 'mainPrize' && (
              <>
                {gameKind === 'Resource' && (
                  <ResourceIcon className={pictureClassName} />
                )}
                {gameKind === 'Material' && (
                  <MaterialsIcon className={pictureClassName} />
                )}
                {gameKind === 'Product' && (
                  <ProductIcon className={pictureClassName} />
                )}
              </>
            )}
            {kind === 'doublePrize' && (
              <div className={cn(css.bonus)}>
                <H2 weight="black">x2</H2>
              </div>
            )}
            {kind === 'stop' && (
              <StopIcon className={cn(pictureClassName, 'mr-1')} />
            )}
            <div className="w-[15px] flex justify-end">
              <StringMain weight="bold">{quantity}</StringMain>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export { CardsOptions };
